// Shared brand constants (not translated)
export const EVENT = {
  name: "Sapiens Celestia",
  phone: "9815487666",
  phoneDisplay: "+91 98154-87666",
  instagram: "littlesapiens.pta",
  hashtag: "#SapiensCelestia2026",
  eventDate: "2026-08-08T10:00:00+05:30",
  venue: "RGMC Gymkhana Club, Patiala",
  mapsLink: "https://maps.google.com/?q=RGMC+Gymkhana+Club+Patiala",
  whatsapp: "https://wa.me/message/D4W2SXEZQO4SK1",
  fee: "₹1,000",
  upiId: "QR919646001027-0113@unionbankofindia",
  upiName: "Little Sapiens",
  bank: "Union Bank of India",
  qrImage: "/payment-qr.jpeg",
  tagline: "Celebrate Talent. Inspire Tomorrow.",
};

export const SPONSORS = [
  "Looks Salon",
  "Malabar Gold & Diamonds",
  "Pure Leaf Tea",
  "Kunal Developers",
  "Charms",
  "Praami's Gaal",
  "Sagar Sweets",
];

// Quiz answer -> talent mapping (client-side scoring)
export const QUIZ_MAP = {
  rhythm: "dancing",
  melody: "singing",
  story: "acting",
  instrument: "instrumental",
  spotlight: "modeling",
  voice: "speaking",
};

export const STRINGS = {
  en: {
    dir: "ltr",
    langLabel: "ਪੰਜਾਬੀ",
    nav: {
      links: [
        { key: "inspiration", label: "Inspiration", href: "#inspiration" },
        { key: "vision", label: "Vision", href: "#vision" },
        { key: "evolution", label: "Evolution", href: "#evolution" },
        { key: "benefits", label: "Why It Matters", href: "#benefits" },
        { key: "play", label: "Play", href: "#games" },
        { key: "share", label: "Share Card", href: "#share" },
        { key: "register", label: "Register", href: "#register" },
      ],
      registerNow: "Register Now",
    },
    hero: {
      presents: "Little Sapiens · Early Years · Presents",
      runway: "Runway of Dreams",
      subtitle:
        "Patiala's Elite Platform for Young Dreamers. A premium stage where confidence, creativity and character take their first bow.",
      cta1: "Claim Your Spot on the Runway",
      cta2: "Play & Explore",
      dreamers: "young dreamers already inspired",
      urgency: "Last few seats left — register now!",
      feeChip: "Registration Fee ₹1,000 only",
      tagline: "Celebrate Talent. Inspire Tomorrow.",
    },
    countdown: {
      title: "The Runway Lights Up In",
      days: "Days",
      hours: "Hours",
      minutes: "Minutes",
      seconds: "Seconds",
      live: "The celebration has begun!",
    },
    marquee: ["Confidence", "Creativity", "Communication", "Character", "Courage", "Expression", "Imagination", "Applause"],
    inspiration: {
      eyebrow: "Global Inspiration",
      title: "Inspired by the World's",
      accent: "Greatest Talent Platforms",
      subtitle:
        "Performing arts unite children across every continent. Sapiens Celestia stands proudly alongside these internationally celebrated formats — carrying their spirit to Patiala.",
      disclaimer:
        "Names shown for inspiration only. Sapiens Celestia is an independent Little Sapiens initiative and is not affiliated with these organizations.",
      sourceLabel: "Source",
      festivals: [
        { flag: "🇺🇸", country: "United States", title: "World Championships of Performing Arts", short: "WCOPA", blurb: "Often called the \"Talent Olympics,\" WCOPA brings together performers from more than 70 countries across singing, dancing, acting, modeling, instrumental music and variety arts — a true global stage for emerging performers.", source: "wcopa.com" },
        { flag: "🇺🇸", country: "United States", title: "Arts Olympiad & World Children's Festival", short: "Arts Olympiad", blurb: "An international creativity movement encouraging children to express themselves through art, imagination, innovation, peace and collaboration, with participation from dozens of countries.", source: "Wikipedia" },
        { flag: "🇨🇦", country: "Canada", title: "Vancouver International Children's Festival", short: "Vancouver ICF", blurb: "One of the world's longest-running professional performing arts festivals for children — presenting theatre, dance, music, puppetry, storytelling and creative experiences for families.", source: "childrensfestival.ca" },
        { flag: "🇺🇸", country: "United States", title: "Golden Gate International Children's & Youth Choral Festival", short: "Golden Gate Choral", blurb: "An international festival bringing together children's choirs from around the world for competition, education and joyful cultural exchange.", source: "piedmontchoirs.org" },
        { flag: "🇪🇸", country: "Spain", title: "World of Talents Festival", short: "World of Talents", blurb: "An international festival celebrating dance, music, orchestras, choirs and performing arts while promoting cultural exchange among young performers.", source: "eaff.eu" },
        { flag: "🇮🇳", country: "India", title: "Jhankriti — World Forum for Art and Culture", short: "Jhankriti", blurb: "One of India's major performing arts platforms, providing opportunities for thousands of young artists across music, dance, theatre and cultural performances.", source: "worldforumforartandculture.com" },
      ],
      patiala: "Patiala",
    },
    vision: {
      eyebrow: "Our Vision",
      title: "A Journey That Begins",
      accent: "With One Step",
      chapters: [
        "Every great performer begins with one courageous step onto a stage.",
        "From neighborhood performances to international championships, every renowned artist once stood where today's young dreamers stand.",
        "Sapiens Celestia is inspired by the world's finest talent celebrations — designed to give children in Punjab a premium stage to explore confidence, creativity, communication and character.",
        "This is not merely a competition. It is the beginning of a lifelong journey.",
      ],
    },
    evolution: {
      eyebrow: "Through the Ages",
      title: "The Evolution",
      accent: "of Talent",
      subtitle:
        "From ancient amphitheatres to global stages — the celebration of performance has always shaped how children grow. In 2026, that legacy arrives in Patiala.",
      items: [
        { era: "Ancient Greece", note: "Music, poetry, theatre and grand public performances." },
        { era: "Ancient India", note: "Natya Shastra, Gurukul traditions, storytelling, dance and music." },
        { era: "Medieval Period", note: "Folk performances and vibrant cultural celebrations." },
        { era: "Royal Courts of India", note: "Classical music, Kathak, Bharatanatyam and instrumental mastery." },
        { era: "Modern Schools", note: "Annual days, cultural festivals, debates and music competitions." },
        { era: "Television Era", note: "Global talent shows and international performing-arts platforms." },
        { era: "Today", note: "International children's festivals connecting cultures worldwide." },
        { era: "2026 · Sapiens Celestia", note: "Little Sapiens' first flagship premium talent platform begins in Patiala." },
      ],
    },
    benefits: {
      eyebrow: "Why Early Stage Exposure Matters",
      title: "One Stage.",
      accent: "A Lifetime of Skills.",
      subtitle:
        "Decades of child-development research show that performing arts nurture the whole child. Each moment on stage quietly builds the abilities that shape confident, capable adults.",
      footnote: "Grounded in research from educational psychology and child-development studies on arts participation.",
      labels: ["Self-Confidence", "Communication", "Leadership", "Creativity", "Emotional Intelligence", "Public Speaking", "Memory", "Teamwork", "Critical Thinking", "Cultural Appreciation", "Problem Solving", "Stage Presence", "Social Interaction", "Self-Expression"],
    },
    promise: {
      eyebrow: "Our Promise",
      title: "Six Promises",
      accent: "to Every Dreamer",
      cards: [
        { title: "Every child performs.", note: "A real stage, real lights, a real moment to shine." },
        { title: "Every child is celebrated.", note: "We applaud courage before we ever count scores." },
        { title: "Every participant is recognized.", note: "Certificates, medals and heartfelt appreciation for all." },
        { title: "Every family makes memories.", note: "Photographs and moments worth keeping for a lifetime." },
        { title: "Every performance builds confidence.", note: "Growth that lasts long after the curtain falls." },
        { title: "Every dream deserves a stage.", note: "Because tomorrow's icons are cheering in today's audience." },
      ],
    },
    sponsors: {
      eyebrow: "Our Proud Sponsors",
      title: "Powered by",
      accent: "Patiala's Finest",
      subtitle: "Wonderful partners who believe in celebrating every child's talent.",
      cta: "Become a Sponsor",
    },
    games: {
      eyebrow: "Play & Explore",
      title: "A Little",
      accent: "Playground of Talent",
      subtitle:
        "While the grown-ups read, little ones can play! Four delightful games designed for ages 3–15 — every tap builds a tiny bit of confidence.",
      playNow: "Play now →",
      cards: [
        { id: "memory", title: "Celestial Memory", desc: "Match the star pairs before they twinkle away.", tag: "Ages 3+" },
        { id: "quiz", title: "Find Your Talent", desc: "Answer a few fun questions to discover your star gift.", tag: "Ages 5+" },
        { id: "canvas", title: "Dream Canvas", desc: "Paint your imagination on a magical night sky.", tag: "All ages" },
        { id: "rhythm", title: "Rhythm Stars", desc: "Watch, remember and tap back the glowing tune.", tag: "Ages 6+" },
      ],
      memory: { moves: "Moves", pairs: "Pairs", reset: "Reset", won: "Bravo! Solved in {n} moves!" },
      quiz: {
        question: "Question",
        of: "of",
        discovering: "Discovering your talent...",
        yourTalent: "Your Star Talent",
        tryAgain: "Try Again",
        registerFor: "Register for {t}",
        questions: [
          { q: "When your favourite song comes on, what do you do first?", options: [ { text: "Start moving & dancing", value: "rhythm" }, { text: "Sing along out loud", value: "melody" }, { text: "Imagine a whole story to it", value: "story" }, { text: "Tap a beat on the table", value: "instrument" } ] },
          { q: "At a family gathering, you love to…", options: [ { text: "Perform a fun dance", value: "rhythm" }, { text: "Present or host confidently", value: "spotlight" }, { text: "Tell an exciting story", value: "voice" }, { text: "Play an instrument", value: "instrument" } ] },
          { q: "Which sounds most exciting to you?", options: [ { text: "Bright lights & a ramp walk", value: "spotlight" }, { text: "A stage with a microphone", value: "melody" }, { text: "Acting out a character", value: "story" }, { text: "Speaking to a big crowd", value: "voice" } ] },
          { q: "Friends would describe you as…", options: [ { text: "Energetic & expressive", value: "rhythm" }, { text: "A natural entertainer", value: "spotlight" }, { text: "A wonderful storyteller", value: "story" }, { text: "Musical & focused", value: "instrument" } ] },
        ],
        talents: {
          singing: { name: "Singing", blurb: "Your voice is your superpower! Melodies live in your heart." },
          dancing: { name: "Dancing", blurb: "You feel the music in every step — the stage is your playground!" },
          acting: { name: "Acting & Drama", blurb: "A born storyteller who can become anyone. Lights, camera, YOU!" },
          instrumental: { name: "Instrumental Music", blurb: "Rhythm runs through you — every beat finds its home." },
          modeling: { name: "Modeling / Ramp Walk", blurb: "Confidence sparkles around you — the runway is calling!" },
          speaking: { name: "Storytelling & Public Speaking", blurb: "Your words light up the room. A future leader on stage!" },
        },
      },
      canvas: { clear: "Clear", save: "Save Art" },
      rhythm: { round: "Round", best: "Best", start: "Start", restart: "Restart", intro: "Press Start to begin", watch: "Watch closely...", turn: "Your turn! Repeat the tune", ready: "Get ready...", cleared: "Perfect! Round {n} cleared 🎉", oops: "Oops! You reached round {n}. Press Start to retry" },
    },
    sharecard: {
      eyebrow: "Share the Magic",
      title: "Create Your",
      accent: "Star Card",
      subtitle: "Make a shareable card for your little performer and post it on Instagram — tag @littlesapiens.pta!",
      nameLabel: "Performer's Name",
      namePh: "Enter a name",
      catLabel: "Category (optional)",
      catPh: "Any category",
    },
    registration: {
      eyebrow: "Registration",
      title: "Secure Your Place",
      accent: "on the Runway",
      intro: "Two magical days. One unforgettable stage. Reserve your child's spot for August 8–9, 2026 at RGMC Gymkhana Club, Patiala. Every registration is confirmed personally over WhatsApp.",
      perks: ["100+ young talents", "Multiple performance categories", "Expert judges & exciting awards", "A certificate for every participant"],
      urgency: "Last few seats left",
      feeLabel: "Registration Fee",
      feeOnly: "only",
      payment: {
        title: "Pay the Registration Fee",
        subtitle: "Scan the QR with any UPI app (GPay, PhonePe, Paytm, BHIM) or pay to the UPI ID below.",
        upiLabel: "UPI ID",
        payeeLabel: "Payee",
        scanHint: "Scan to pay",
        after: "After paying, tap below and share your payment screenshot on WhatsApp to confirm your child's seat.",
        paidBtn: "I've Paid — Confirm on WhatsApp",
      },
      categories: ["Singing", "Dancing", "Acting & Drama", "Instrumental Music", "Modeling / Ramp Walk", "Storytelling & Public Speaking", "Fashion & Variety Arts"],
      childName: "Child's Name *",
      childNamePh: "Little star's name",
      age: "Age (3–15) *",
      agePh: "e.g. 8",
      city: "City",
      cityPh: "Patiala",
      category: "Performance Category *",
      categoryPh: "Choose a category",
      parentName: "Parent Name *",
      parentNamePh: "Your name",
      phone: "WhatsApp Number *",
      phonePh: "10-digit mobile",
      note: "A note for us (optional)",
      notePh: "Anything you'd like us to know?",
      submit: "Reserve My Spot",
      submitting: "Reserving...",
      disclaimer: "No payment now — we'll confirm everything over WhatsApp.",
      errFill: "Please fill in all required fields.",
      errAge: "Age must be between 3 and 15 years.",
      toast: "Spot reserved! 🎉 Confirm on WhatsApp to lock it in.",
      success: {
        title: "You're on the list!",
        ref: "Booking reference",
        step: "One last step — send us a quick WhatsApp so we can confirm {name}'s spot and share the schedule.",
        whatsapp: "Confirm on WhatsApp",
        another: "Register another child",
        share: "Create a Shareable Card",
        shareTitle: "Share the Excitement!",
        shareHint: "Save it and post on Instagram — tag @littlesapiens.pta!",
        download: "Download",
        shareBtn: "Share",
      },
      waText: "Hello Little Sapiens! 🌟 New registration for Sapiens Celestia 2026:\n\nChild: {name} (Age {age})\nCategory: {cat}\nParent: {parent}\nWhatsApp: {phone}\nCity: {city}\nBooking Ref: {ref}\n\nI've paid the ₹1,000 registration fee and will share the payment screenshot here. Please confirm the seat.",
    },
    footer: {
      legacyEyebrow: "Future Vision",
      legacyTitle: "The Beginning of a",
      legacyAccent: "Legacy",
      legacyBody: "Our vision is to grow Sapiens Celestia into one of North India's most respected children's talent festivals — welcoming young performers from across Punjab, neighbouring states, and eventually all of India through annual editions, professional production, world-class judging and unforgettable experiences.",
      legacyNote: "Little Sapiens' first flagship premium talent platform in Patiala — inspired by global standards, built for our little dreamers.",
      legacyCta: "Be Part of Edition One",
      venueTitle: "Find the Runway",
      venueName: "RGMC Gymkhana Club, Patiala",
      venueBody: "Follow the golden glow to the Gymkhana Club road — where Patiala's grand old trees line the way. When you spot happy families and the sparkle of stage lights, you've arrived. Just look for the little stars in their finest outfits! ✨",
      mapsCta: "Open in Google Maps",
      whatsappChat: "Chat on WhatsApp",
      homeTitle: "Our Little Home",
      homeName: "Little Sapiens · Early Years, Patiala",
      homeBody: "Tucked in a cheerful corner of Patiala where crayons meet curiosity and every giggle echoes down the hallway. Pop in for a hello — there's usually a story being told and a tiny dance happening somewhere. 🎨",
      contactTitle: "Say Hello",
      whatsapp: "WhatsApp",
      call: "Call",
      copyright: "© 2026 Little Sapiens Early Years, Patiala. Crafted with love for little dreamers.",
      credit: "Designed & developed by M Sivanath",
      waText: "Hi Little Sapiens! I'd love to know more about Sapiens Celestia 2026.",
    },
  },

  pa: {
    dir: "ltr",
    langLabel: "English",
    nav: {
      links: [
        { key: "inspiration", label: "ਪ੍ਰੇਰਣਾ", href: "#inspiration" },
        { key: "vision", label: "ਦ੍ਰਿਸ਼ਟੀ", href: "#vision" },
        { key: "evolution", label: "ਵਿਕਾਸ", href: "#evolution" },
        { key: "benefits", label: "ਕਿਉਂ ਜ਼ਰੂਰੀ", href: "#benefits" },
        { key: "play", label: "ਖੇਡੋ", href: "#games" },
        { key: "share", label: "ਸ਼ੇਅਰ ਕਾਰਡ", href: "#share" },
        { key: "register", label: "ਰਜਿਸਟਰ", href: "#register" },
      ],
      registerNow: "ਹੁਣੇ ਰਜਿਸਟਰ ਕਰੋ",
    },
    hero: {
      presents: "ਲਿਟਲ ਸੇਪੀਅਨਜ਼ · ਅਰਲੀ ਯੀਅਰਜ਼ · ਪੇਸ਼ ਕਰਦੇ ਹਨ",
      runway: "ਸੁਪਨਿਆਂ ਦੀ ਰੈਂਪ",
      subtitle:
        "ਪਟਿਆਲਾ ਦਾ ਨੌਜਵਾਨ ਸੁਪਨਸਾਜ਼ਾਂ ਲਈ ਸ਼ਾਨਦਾਰ ਮੰਚ। ਇੱਕ ਪ੍ਰੀਮੀਅਮ ਸਟੇਜ ਜਿੱਥੇ ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਸਿਰਜਣਾਤਮਕਤਾ ਅਤੇ ਚਰਿੱਤਰ ਆਪਣਾ ਪਹਿਲਾ ਪ੍ਰਦਰਸ਼ਨ ਕਰਦੇ ਹਨ।",
      cta1: "ਰੈਂਪ 'ਤੇ ਆਪਣੀ ਜਗ੍ਹਾ ਬੁੱਕ ਕਰੋ",
      cta2: "ਖੇਡੋ ਤੇ ਖੋਜੋ",
      dreamers: "ਨੌਜਵਾਨ ਸੁਪਨਸਾਜ਼ ਪਹਿਲਾਂ ਹੀ ਪ੍ਰੇਰਿਤ",
      urgency: "ਕੁਝ ਸੀਟਾਂ ਬਾਕੀ — ਹੁਣੇ ਰਜਿਸਟਰ ਕਰੋ!",
      feeChip: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫੀਸ ਸਿਰਫ਼ ₹1,000",
      tagline: "ਟੈਲੇਂਟ ਦਾ ਜਸ਼ਨ। ਭਵਿੱਖ ਦੀ ਪ੍ਰੇਰਣਾ।",
    },
    countdown: {
      title: "ਰੈਂਪ ਰੌਸ਼ਨ ਹੋਵੇਗੀ",
      days: "ਦਿਨ",
      hours: "ਘੰਟੇ",
      minutes: "ਮਿੰਟ",
      seconds: "ਸਕਿੰਟ",
      live: "ਜਸ਼ਨ ਸ਼ੁਰੂ ਹੋ ਗਿਆ ਹੈ!",
    },
    marquee: ["ਆਤਮ-ਵਿਸ਼ਵਾਸ", "ਸਿਰਜਣਾਤਮਕਤਾ", "ਸੰਚਾਰ", "ਚਰਿੱਤਰ", "ਹੌਸਲਾ", "ਪ੍ਰਗਟਾਵਾ", "ਕਲਪਨਾ", "ਤਾੜੀਆਂ"],
    inspiration: {
      eyebrow: "ਵਿਸ਼ਵ ਪ੍ਰੇਰਣਾ",
      title: "ਦੁਨੀਆ ਦੇ ਸਭ ਤੋਂ",
      accent: "ਵੱਡੇ ਟੈਲੇਂਟ ਮੰਚਾਂ ਤੋਂ ਪ੍ਰੇਰਿਤ",
      subtitle:
        "ਪਰਫਾਰਮਿੰਗ ਆਰਟਸ ਹਰ ਮਹਾਂਦੀਪ ਦੇ ਬੱਚਿਆਂ ਨੂੰ ਜੋੜਦੀ ਹੈ। ਸੇਪੀਅਨਜ਼ ਸੇਲੇਸਟੀਆ ਇਨ੍ਹਾਂ ਅੰਤਰਰਾਸ਼ਟਰੀ ਮੰਚਾਂ ਦੇ ਨਾਲ ਮਾਣ ਨਾਲ ਖੜ੍ਹਾ ਹੈ — ਉਨ੍ਹਾਂ ਦੀ ਭਾਵਨਾ ਪਟਿਆਲਾ ਤੱਕ ਲੈ ਕੇ ਆਉਂਦਾ ਹੈ।",
      disclaimer:
        "ਨਾਮ ਸਿਰਫ਼ ਪ੍ਰੇਰਣਾ ਲਈ ਦਿਖਾਏ ਗਏ ਹਨ। ਸੇਪੀਅਨਜ਼ ਸੇਲੇਸਟੀਆ ਲਿਟਲ ਸੇਪੀਅਨਜ਼ ਦੀ ਸੁਤੰਤਰ ਪਹਿਲ ਹੈ ਅਤੇ ਇਹਨਾਂ ਸੰਸਥਾਵਾਂ ਨਾਲ ਸਬੰਧਤ ਨਹੀਂ ਹੈ।",
      sourceLabel: "ਸਰੋਤ",
      festivals: [
        { flag: "🇺🇸", country: "ਅਮਰੀਕਾ", title: "World Championships of Performing Arts", short: "WCOPA", blurb: "\"ਟੈਲੇਂਟ ਓਲੰਪਿਕਸ\" ਵਜੋਂ ਜਾਣਿਆ ਜਾਂਦਾ, WCOPA 70 ਤੋਂ ਵੱਧ ਦੇਸ਼ਾਂ ਦੇ ਕਲਾਕਾਰਾਂ ਨੂੰ ਗਾਇਨ, ਨਾਚ, ਅਦਾਕਾਰੀ, ਮਾਡਲਿੰਗ, ਸਾਜ਼ ਸੰਗੀਤ ਤੇ ਵੰਨ-ਸੁਵੰਨੀਆਂ ਕਲਾਵਾਂ ਵਿੱਚ ਇਕੱਠਾ ਕਰਦਾ ਹੈ।", source: "wcopa.com" },
        { flag: "🇺🇸", country: "ਅਮਰੀਕਾ", title: "Arts Olympiad & World Children's Festival", short: "Arts Olympiad", blurb: "ਇੱਕ ਅੰਤਰਰਾਸ਼ਟਰੀ ਸਿਰਜਣਾਤਮਕ ਲਹਿਰ ਜੋ ਬੱਚਿਆਂ ਨੂੰ ਕਲਾ, ਕਲਪਨਾ, ਨਵੀਨਤਾ, ਸ਼ਾਂਤੀ ਤੇ ਸਹਿਯੋਗ ਰਾਹੀਂ ਪ੍ਰਗਟਾਵੇ ਲਈ ਉਤਸ਼ਾਹਿਤ ਕਰਦੀ ਹੈ।", source: "Wikipedia" },
        { flag: "🇨🇦", country: "ਕੈਨੇਡਾ", title: "Vancouver International Children's Festival", short: "Vancouver ICF", blurb: "ਬੱਚਿਆਂ ਲਈ ਦੁਨੀਆ ਦੇ ਸਭ ਤੋਂ ਪੁਰਾਣੇ ਪੇਸ਼ੇਵਰ ਪਰਫਾਰਮਿੰਗ ਆਰਟਸ ਮੇਲਿਆਂ ਵਿੱਚੋਂ ਇੱਕ — ਥੀਏਟਰ, ਨਾਚ, ਸੰਗੀਤ, ਕਠਪੁਤਲੀ ਤੇ ਕਹਾਣੀਆਂ ਪੇਸ਼ ਕਰਦਾ ਹੈ।", source: "childrensfestival.ca" },
        { flag: "🇺🇸", country: "ਅਮਰੀਕਾ", title: "Golden Gate International Children's & Youth Choral Festival", short: "Golden Gate Choral", blurb: "ਇੱਕ ਅੰਤਰਰਾਸ਼ਟਰੀ ਮੇਲਾ ਜੋ ਦੁਨੀਆ ਭਰ ਦੇ ਬੱਚਿਆਂ ਦੀਆਂ ਗਾਇਕ ਮੰਡਲੀਆਂ ਨੂੰ ਮੁਕਾਬਲੇ ਤੇ ਸੱਭਿਆਚਾਰਕ ਸਾਂਝ ਲਈ ਇਕੱਠਾ ਕਰਦਾ ਹੈ।", source: "piedmontchoirs.org" },
        { flag: "🇪🇸", country: "ਸਪੇਨ", title: "World of Talents Festival", short: "World of Talents", blurb: "ਇੱਕ ਅੰਤਰਰਾਸ਼ਟਰੀ ਮੇਲਾ ਜੋ ਨਾਚ, ਸੰਗੀਤ, ਆਰਕੈਸਟਰਾ ਤੇ ਗਾਇਕ ਮੰਡਲੀਆਂ ਦਾ ਜਸ਼ਨ ਮਨਾਉਂਦਾ ਹੈ ਤੇ ਸੱਭਿਆਚਾਰਕ ਸਾਂਝ ਨੂੰ ਵਧਾਵਾ ਦਿੰਦਾ ਹੈ।", source: "eaff.eu" },
        { flag: "🇮🇳", country: "ਭਾਰਤ", title: "Jhankriti — World Forum for Art and Culture", short: "Jhankriti", blurb: "ਭਾਰਤ ਦੇ ਵੱਡੇ ਪਰਫਾਰਮਿੰਗ ਆਰਟਸ ਮੰਚਾਂ ਵਿੱਚੋਂ ਇੱਕ, ਜੋ ਹਜ਼ਾਰਾਂ ਨੌਜਵਾਨ ਕਲਾਕਾਰਾਂ ਨੂੰ ਸੰਗੀਤ, ਨਾਚ ਤੇ ਥੀਏਟਰ ਦੇ ਮੌਕੇ ਦਿੰਦਾ ਹੈ।", source: "worldforumforartandculture.com" },
      ],
      patiala: "ਪਟਿਆਲਾ",
    },
    vision: {
      eyebrow: "ਸਾਡੀ ਦ੍ਰਿਸ਼ਟੀ",
      title: "ਇੱਕ ਸਫ਼ਰ ਜੋ ਸ਼ੁਰੂ ਹੁੰਦਾ ਹੈ",
      accent: "ਇੱਕ ਕਦਮ ਨਾਲ",
      chapters: [
        "ਹਰ ਮਹਾਨ ਕਲਾਕਾਰ ਦੀ ਸ਼ੁਰੂਆਤ ਸਟੇਜ 'ਤੇ ਇੱਕ ਹੌਸਲੇ ਭਰੇ ਕਦਮ ਨਾਲ ਹੁੰਦੀ ਹੈ।",
        "ਮੁਹੱਲੇ ਦੇ ਪ੍ਰੋਗਰਾਮਾਂ ਤੋਂ ਲੈ ਕੇ ਅੰਤਰਰਾਸ਼ਟਰੀ ਚੈਂਪੀਅਨਸ਼ਿਪਾਂ ਤੱਕ, ਹਰ ਮਸ਼ਹੂਰ ਕਲਾਕਾਰ ਕਦੇ ਉੱਥੇ ਹੀ ਖੜ੍ਹਾ ਸੀ ਜਿੱਥੇ ਅੱਜ ਦੇ ਨੌਜਵਾਨ ਸੁਪਨਸਾਜ਼ ਖੜ੍ਹੇ ਹਨ।",
        "ਸੇਪੀਅਨਜ਼ ਸੇਲੇਸਟੀਆ ਦੁਨੀਆ ਦੇ ਬਿਹਤਰੀਨ ਟੈਲੇਂਟ ਜਸ਼ਨਾਂ ਤੋਂ ਪ੍ਰੇਰਿਤ ਹੈ — ਪੰਜਾਬ ਦੇ ਬੱਚਿਆਂ ਨੂੰ ਆਤਮ-ਵਿਸ਼ਵਾਸ, ਸਿਰਜਣਾਤਮਕਤਾ, ਸੰਚਾਰ ਤੇ ਚਰਿੱਤਰ ਦੀ ਖੋਜ ਲਈ ਇੱਕ ਪ੍ਰੀਮੀਅਮ ਸਟੇਜ ਦੇਣ ਲਈ।",
        "ਇਹ ਸਿਰਫ਼ ਇੱਕ ਮੁਕਾਬਲਾ ਨਹੀਂ ਹੈ। ਇਹ ਜ਼ਿੰਦਗੀ ਭਰ ਦੇ ਸਫ਼ਰ ਦੀ ਸ਼ੁਰੂਆਤ ਹੈ।",
      ],
    },
    evolution: {
      eyebrow: "ਯੁੱਗਾਂ ਦੇ ਦੌਰਾਨ",
      title: "ਟੈਲੇਂਟ ਦਾ",
      accent: "ਵਿਕਾਸ",
      subtitle:
        "ਪ੍ਰਾਚੀਨ ਰੰਗਸ਼ਾਲਾਵਾਂ ਤੋਂ ਲੈ ਕੇ ਵਿਸ਼ਵ ਮੰਚਾਂ ਤੱਕ — ਪ੍ਰਦਰਸ਼ਨ ਦੇ ਜਸ਼ਨ ਨੇ ਹਮੇਸ਼ਾ ਬੱਚਿਆਂ ਦੇ ਵਿਕਾਸ ਨੂੰ ਆਕਾਰ ਦਿੱਤਾ ਹੈ। 2026 ਵਿੱਚ, ਇਹ ਵਿਰਾਸਤ ਪਟਿਆਲਾ ਪਹੁੰਚਦੀ ਹੈ।",
      items: [
        { era: "ਪ੍ਰਾਚੀਨ ਯੂਨਾਨ", note: "ਸੰਗੀਤ, ਕਵਿਤਾ, ਥੀਏਟਰ ਤੇ ਸ਼ਾਨਦਾਰ ਜਨਤਕ ਪ੍ਰਦਰਸ਼ਨ।" },
        { era: "ਪ੍ਰਾਚੀਨ ਭਾਰਤ", note: "ਨਾਟਯ ਸ਼ਾਸਤਰ, ਗੁਰੂਕੁਲ ਪਰੰਪਰਾ, ਕਹਾਣੀਆਂ, ਨਾਚ ਤੇ ਸੰਗੀਤ।" },
        { era: "ਮੱਧਕਾਲੀਨ ਦੌਰ", note: "ਲੋਕ ਪ੍ਰਦਰਸ਼ਨ ਤੇ ਰੰਗੀਨ ਸੱਭਿਆਚਾਰਕ ਜਸ਼ਨ।" },
        { era: "ਭਾਰਤ ਦੇ ਰਾਜ ਦਰਬਾਰ", note: "ਕਲਾਸੀਕਲ ਸੰਗੀਤ, ਕਥਕ, ਭਰਤਨਾਟਯਮ ਤੇ ਸਾਜ਼ ਵਿੱਚ ਮੁਹਾਰਤ।" },
        { era: "ਆਧੁਨਿਕ ਸਕੂਲ", note: "ਸਾਲਾਨਾ ਦਿਵਸ, ਸੱਭਿਆਚਾਰਕ ਮੇਲੇ, ਬਹਿਸਾਂ ਤੇ ਸੰਗੀਤ ਮੁਕਾਬਲੇ।" },
        { era: "ਟੈਲੀਵਿਜ਼ਨ ਯੁੱਗ", note: "ਵਿਸ਼ਵ ਟੈਲੇਂਟ ਸ਼ੋਅ ਤੇ ਅੰਤਰਰਾਸ਼ਟਰੀ ਪਰਫਾਰਮਿੰਗ ਆਰਟਸ ਮੰਚ।" },
        { era: "ਅੱਜ", note: "ਅੰਤਰਰਾਸ਼ਟਰੀ ਬਾਲ ਮੇਲੇ ਜੋ ਦੁਨੀਆ ਭਰ ਦੇ ਸੱਭਿਆਚਾਰਾਂ ਨੂੰ ਜੋੜਦੇ ਹਨ।" },
        { era: "2026 · ਸੇਪੀਅਨਜ਼ ਸੇਲੇਸਟੀਆ", note: "ਲਿਟਲ ਸੇਪੀਅਨਜ਼ ਦਾ ਪਹਿਲਾ ਫਲੈਗਸ਼ਿਪ ਪ੍ਰੀਮੀਅਮ ਟੈਲੇਂਟ ਮੰਚ ਪਟਿਆਲਾ ਵਿੱਚ ਸ਼ੁਰੂ।" },
      ],
    },
    benefits: {
      eyebrow: "ਸ਼ੁਰੂਆਤੀ ਸਟੇਜ ਦਾ ਤਜਰਬਾ ਕਿਉਂ ਜ਼ਰੂਰੀ ਹੈ",
      title: "ਇੱਕ ਸਟੇਜ।",
      accent: "ਜ਼ਿੰਦਗੀ ਭਰ ਦੇ ਹੁਨਰ।",
      subtitle:
        "ਦਹਾਕਿਆਂ ਦੀ ਬਾਲ-ਵਿਕਾਸ ਖੋਜ ਦੱਸਦੀ ਹੈ ਕਿ ਪਰਫਾਰਮਿੰਗ ਆਰਟਸ ਪੂਰੇ ਬੱਚੇ ਦਾ ਪਾਲਣ-ਪੋਸ਼ਣ ਕਰਦੀ ਹੈ। ਸਟੇਜ 'ਤੇ ਹਰ ਪਲ ਚੁੱਪਚਾਪ ਉਹ ਯੋਗਤਾਵਾਂ ਬਣਾਉਂਦਾ ਹੈ ਜੋ ਆਤਮ-ਵਿਸ਼ਵਾਸੀ ਬਾਲਗ ਬਣਾਉਂਦੀਆਂ ਹਨ।",
      footnote: "ਵਿੱਦਿਅਕ ਮਨੋਵਿਗਿਆਨ ਤੇ ਬਾਲ-ਵਿਕਾਸ ਅਧਿਐਨਾਂ ਦੀ ਖੋਜ 'ਤੇ ਆਧਾਰਿਤ।",
      labels: ["ਆਤਮ-ਵਿਸ਼ਵਾਸ", "ਸੰਚਾਰ", "ਅਗਵਾਈ", "ਸਿਰਜਣਾਤਮਕਤਾ", "ਭਾਵਨਾਤਮਕ ਸਮਝ", "ਜਨਤਕ ਭਾਸ਼ਣ", "ਯਾਦਦਾਸ਼ਤ", "ਟੀਮ ਵਰਕ", "ਆਲੋਚਨਾਤਮਕ ਸੋਚ", "ਸੱਭਿਆਚਾਰਕ ਕਦਰ", "ਸਮੱਸਿਆ ਹੱਲ", "ਸਟੇਜ ਹਾਜ਼ਰੀ", "ਸਮਾਜਿਕ ਮੇਲ-ਜੋਲ", "ਸਵੈ-ਪ੍ਰਗਟਾਵਾ"],
    },
    promise: {
      eyebrow: "ਸਾਡਾ ਵਾਅਦਾ",
      title: "ਹਰ ਸੁਪਨਸਾਜ਼ ਨਾਲ",
      accent: "ਛੇ ਵਾਅਦੇ",
      cards: [
        { title: "ਹਰ ਬੱਚਾ ਪ੍ਰਦਰਸ਼ਨ ਕਰਦਾ ਹੈ।", note: "ਇੱਕ ਅਸਲੀ ਸਟੇਜ, ਅਸਲੀ ਰੌਸ਼ਨੀਆਂ, ਚਮਕਣ ਦਾ ਅਸਲੀ ਪਲ।" },
        { title: "ਹਰ ਬੱਚੇ ਦਾ ਜਸ਼ਨ ਮਨਾਇਆ ਜਾਂਦਾ ਹੈ।", note: "ਅੰਕ ਗਿਣਨ ਤੋਂ ਪਹਿਲਾਂ ਅਸੀਂ ਹੌਸਲੇ ਦੀ ਤਾੜੀ ਵਜਾਉਂਦੇ ਹਾਂ।" },
        { title: "ਹਰ ਭਾਗੀਦਾਰ ਦੀ ਪਛਾਣ ਹੁੰਦੀ ਹੈ।", note: "ਸਾਰਿਆਂ ਲਈ ਸਰਟੀਫਿਕੇਟ, ਮੈਡਲ ਤੇ ਦਿਲੋਂ ਸ਼ਲਾਘਾ।" },
        { title: "ਹਰ ਪਰਿਵਾਰ ਯਾਦਾਂ ਬਣਾਉਂਦਾ ਹੈ।", note: "ਜ਼ਿੰਦਗੀ ਭਰ ਸੰਭਾਲਣ ਯੋਗ ਤਸਵੀਰਾਂ ਤੇ ਪਲ।" },
        { title: "ਹਰ ਪ੍ਰਦਰਸ਼ਨ ਆਤਮ-ਵਿਸ਼ਵਾਸ ਬਣਾਉਂਦਾ ਹੈ।", note: "ਵਿਕਾਸ ਜੋ ਪਰਦਾ ਡਿੱਗਣ ਤੋਂ ਬਾਅਦ ਵੀ ਰਹਿੰਦਾ ਹੈ।" },
        { title: "ਹਰ ਸੁਪਨਾ ਸਟੇਜ ਦਾ ਹੱਕਦਾਰ ਹੈ।", note: "ਕਿਉਂਕਿ ਕੱਲ੍ਹ ਦੇ ਸਿਤਾਰੇ ਅੱਜ ਦੀ ਭੀੜ ਵਿੱਚ ਤਾੜੀਆਂ ਵਜਾ ਰਹੇ ਹਨ।" },
      ],
    },
    sponsors: {
      eyebrow: "ਸਾਡੇ ਮਾਣਯੋਗ ਸਪਾਂਸਰ",
      title: "ਸਹਿਯੋਗ ਨਾਲ",
      accent: "ਪਟਿਆਲਾ ਦੇ ਬਿਹਤਰੀਨ",
      subtitle: "ਸ਼ਾਨਦਾਰ ਭਾਈਵਾਲ ਜੋ ਹਰ ਬੱਚੇ ਦੇ ਟੈਲੇਂਟ ਦੇ ਜਸ਼ਨ ਵਿੱਚ ਵਿਸ਼ਵਾਸ ਰੱਖਦੇ ਹਨ।",
      cta: "ਸਪਾਂਸਰ ਬਣੋ",
    },
    games: {
      eyebrow: "ਖੇਡੋ ਤੇ ਖੋਜੋ",
      title: "ਟੈਲੇਂਟ ਦਾ ਇੱਕ ਛੋਟਾ",
      accent: "ਖੇਡ ਮੈਦਾਨ",
      subtitle:
        "ਜਦੋਂ ਵੱਡੇ ਪੜ੍ਹਦੇ ਹਨ, ਛੋਟੇ ਖੇਡ ਸਕਦੇ ਹਨ! 3–15 ਸਾਲ ਦੇ ਬੱਚਿਆਂ ਲਈ ਚਾਰ ਮਜ਼ੇਦਾਰ ਖੇਡਾਂ — ਹਰ ਟੈਪ ਥੋੜ੍ਹਾ ਆਤਮ-ਵਿਸ਼ਵਾਸ ਬਣਾਉਂਦਾ ਹੈ।",
      playNow: "ਹੁਣੇ ਖੇਡੋ →",
      cards: [
        { id: "memory", title: "ਸਿਤਾਰਾ ਯਾਦਦਾਸ਼ਤ", desc: "ਸਿਤਾਰਿਆਂ ਦੇ ਜੋੜੇ ਮਿਲਾਓ ਇਸ ਤੋਂ ਪਹਿਲਾਂ ਕਿ ਉਹ ਟਿਮਟਿਮਾ ਕੇ ਗਾਇਬ ਹੋਣ।", tag: "3+ ਸਾਲ" },
        { id: "quiz", title: "ਆਪਣਾ ਟੈਲੇਂਟ ਲੱਭੋ", desc: "ਕੁਝ ਮਜ਼ੇਦਾਰ ਸਵਾਲਾਂ ਦੇ ਜਵਾਬ ਦੇ ਕੇ ਆਪਣੀ ਪ੍ਰਤਿਭਾ ਖੋਜੋ।", tag: "5+ ਸਾਲ" },
        { id: "canvas", title: "ਸੁਪਨ ਕੈਨਵਸ", desc: "ਜਾਦੂਈ ਰਾਤ ਦੇ ਅਸਮਾਨ 'ਤੇ ਆਪਣੀ ਕਲਪਨਾ ਰੰਗੋ।", tag: "ਹਰ ਉਮਰ" },
        { id: "rhythm", title: "ਤਾਲ ਸਿਤਾਰੇ", desc: "ਵੇਖੋ, ਯਾਦ ਰੱਖੋ ਤੇ ਚਮਕਦੀ ਧੁਨ ਵਾਪਸ ਟੈਪ ਕਰੋ।", tag: "6+ ਸਾਲ" },
      ],
      memory: { moves: "ਚਾਲਾਂ", pairs: "ਜੋੜੇ", reset: "ਰੀਸੈੱਟ", won: "ਸ਼ਾਬਾਸ਼! {n} ਚਾਲਾਂ ਵਿੱਚ ਹੱਲ!" },
      quiz: {
        question: "ਸਵਾਲ",
        of: "ਵਿੱਚੋਂ",
        discovering: "ਤੁਹਾਡਾ ਟੈਲੇਂਟ ਲੱਭ ਰਹੇ ਹਾਂ...",
        yourTalent: "ਤੁਹਾਡਾ ਸਿਤਾਰਾ ਟੈਲੇਂਟ",
        tryAgain: "ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼",
        registerFor: "{t} ਲਈ ਰਜਿਸਟਰ ਕਰੋ",
        questions: [
          { q: "ਜਦੋਂ ਤੁਹਾਡਾ ਮਨਪਸੰਦ ਗੀਤ ਵੱਜਦਾ ਹੈ, ਤੁਸੀਂ ਪਹਿਲਾਂ ਕੀ ਕਰਦੇ ਹੋ?", options: [ { text: "ਹਿੱਲਣਾ ਤੇ ਨੱਚਣਾ ਸ਼ੁਰੂ", value: "rhythm" }, { text: "ਉੱਚੀ ਆਵਾਜ਼ ਵਿੱਚ ਗਾਉਣਾ", value: "melody" }, { text: "ਇਸ ਦੀ ਪੂਰੀ ਕਹਾਣੀ ਸੋਚਣਾ", value: "story" }, { text: "ਮੇਜ਼ 'ਤੇ ਤਾਲ ਵਜਾਉਣਾ", value: "instrument" } ] },
          { q: "ਪਰਿਵਾਰਕ ਇਕੱਠ ਵਿੱਚ, ਤੁਹਾਨੂੰ ਪਸੰਦ ਹੈ…", options: [ { text: "ਮਜ਼ੇਦਾਰ ਨਾਚ ਕਰਨਾ", value: "rhythm" }, { text: "ਵਿਸ਼ਵਾਸ ਨਾਲ ਮੇਜ਼ਬਾਨੀ ਕਰਨਾ", value: "spotlight" }, { text: "ਦਿਲਚਸਪ ਕਹਾਣੀ ਸੁਣਾਉਣਾ", value: "voice" }, { text: "ਕੋਈ ਸਾਜ਼ ਵਜਾਉਣਾ", value: "instrument" } ] },
          { q: "ਕਿਹੜੀ ਗੱਲ ਸਭ ਤੋਂ ਦਿਲਚਸਪ ਲੱਗਦੀ ਹੈ?", options: [ { text: "ਚਮਕਦੀਆਂ ਰੌਸ਼ਨੀਆਂ ਤੇ ਰੈਂਪ ਵਾਕ", value: "spotlight" }, { text: "ਮਾਈਕ ਵਾਲੀ ਸਟੇਜ", value: "melody" }, { text: "ਕਿਸੇ ਕਿਰਦਾਰ ਦੀ ਅਦਾਕਾਰੀ", value: "story" }, { text: "ਵੱਡੀ ਭੀੜ ਨਾਲ ਗੱਲ ਕਰਨਾ", value: "voice" } ] },
          { q: "ਦੋਸਤ ਤੁਹਾਨੂੰ ਕਿਵੇਂ ਦੱਸਣਗੇ…", options: [ { text: "ਊਰਜਾਵਾਨ ਤੇ ਪ੍ਰਗਟਾਵਾ ਕਰਨ ਵਾਲਾ", value: "rhythm" }, { text: "ਕੁਦਰਤੀ ਮਨੋਰੰਜਕ", value: "spotlight" }, { text: "ਸ਼ਾਨਦਾਰ ਕਹਾਣੀਕਾਰ", value: "story" }, { text: "ਸੰਗੀਤਕ ਤੇ ਕੇਂਦ੍ਰਿਤ", value: "instrument" } ] },
        ],
        talents: {
          singing: { name: "ਗਾਇਨ", blurb: "ਤੁਹਾਡੀ ਆਵਾਜ਼ ਤੁਹਾਡੀ ਸ਼ਕਤੀ ਹੈ! ਧੁਨਾਂ ਤੁਹਾਡੇ ਦਿਲ ਵਿੱਚ ਵੱਸਦੀਆਂ ਹਨ।" },
          dancing: { name: "ਨਾਚ", blurb: "ਤੁਸੀਂ ਹਰ ਕਦਮ ਵਿੱਚ ਸੰਗੀਤ ਮਹਿਸੂਸ ਕਰਦੇ ਹੋ — ਸਟੇਜ ਤੁਹਾਡਾ ਖੇਡ ਮੈਦਾਨ ਹੈ!" },
          acting: { name: "ਅਦਾਕਾਰੀ ਤੇ ਡਰਾਮਾ", blurb: "ਜਨਮਜਾਤ ਕਹਾਣੀਕਾਰ ਜੋ ਕੋਈ ਵੀ ਬਣ ਸਕਦਾ ਹੈ। ਲਾਈਟਸ, ਕੈਮਰਾ, ਤੁਸੀਂ!" },
          instrumental: { name: "ਸਾਜ਼ ਸੰਗੀਤ", blurb: "ਤਾਲ ਤੁਹਾਡੇ ਅੰਦਰ ਵੱਗਦੀ ਹੈ — ਹਰ ਧੜਕਣ ਆਪਣੀ ਥਾਂ ਲੱਭ ਲੈਂਦੀ ਹੈ।" },
          modeling: { name: "ਮਾਡਲਿੰਗ / ਰੈਂਪ ਵਾਕ", blurb: "ਤੁਹਾਡੇ ਦੁਆਲੇ ਵਿਸ਼ਵਾਸ ਚਮਕਦਾ ਹੈ — ਰੈਂਪ ਤੁਹਾਨੂੰ ਬੁਲਾ ਰਹੀ ਹੈ!" },
          speaking: { name: "ਕਹਾਣੀ ਤੇ ਜਨਤਕ ਭਾਸ਼ਣ", blurb: "ਤੁਹਾਡੇ ਸ਼ਬਦ ਕਮਰੇ ਨੂੰ ਰੌਸ਼ਨ ਕਰਦੇ ਹਨ। ਸਟੇਜ 'ਤੇ ਭਵਿੱਖ ਦਾ ਆਗੂ!" },
        },
      },
      canvas: { clear: "ਸਾਫ਼ ਕਰੋ", save: "ਕਲਾ ਸੰਭਾਲੋ" },
      rhythm: { round: "ਰਾਊਂਡ", best: "ਬਿਹਤਰੀਨ", start: "ਸ਼ੁਰੂ", restart: "ਦੁਬਾਰਾ", intro: "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਸਟਾਰਟ ਦਬਾਓ", watch: "ਧਿਆਨ ਨਾਲ ਵੇਖੋ...", turn: "ਤੁਹਾਡੀ ਵਾਰੀ! ਧੁਨ ਦੁਹਰਾਓ", ready: "ਤਿਆਰ ਹੋ ਜਾਓ...", cleared: "ਸ਼ਾਨਦਾਰ! ਰਾਊਂਡ {n} ਪੂਰਾ 🎉", oops: "ਓਹੋ! ਤੁਸੀਂ ਰਾਊਂਡ {n} ਤੱਕ ਪਹੁੰਚੇ। ਦੁਬਾਰਾ ਲਈ ਸਟਾਰਟ ਦਬਾਓ" },
    },
    sharecard: {
      eyebrow: "ਜਾਦੂ ਸਾਂਝਾ ਕਰੋ",
      title: "ਆਪਣਾ",
      accent: "ਸਿਤਾਰਾ ਕਾਰਡ ਬਣਾਓ",
      subtitle: "ਆਪਣੇ ਨੰਨ੍ਹੇ ਕਲਾਕਾਰ ਲਈ ਸ਼ੇਅਰ ਕਾਰਡ ਬਣਾਓ ਤੇ ਇੰਸਟਾਗ੍ਰਾਮ 'ਤੇ ਪੋਸਟ ਕਰੋ — @littlesapiens.pta ਨੂੰ ਟੈਗ ਕਰੋ!",
      nameLabel: "ਕਲਾਕਾਰ ਦਾ ਨਾਮ",
      namePh: "ਨਾਮ ਦਰਜ ਕਰੋ",
      catLabel: "ਸ਼੍ਰੇਣੀ (ਵਿਕਲਪਿਕ)",
      catPh: "ਕੋਈ ਵੀ ਸ਼੍ਰੇਣੀ",
    },
    registration: {
      eyebrow: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
      title: "ਰੈਂਪ 'ਤੇ ਆਪਣੀ",
      accent: "ਜਗ੍ਹਾ ਸੁਰੱਖਿਅਤ ਕਰੋ",
      intro: "ਦੋ ਜਾਦੂਈ ਦਿਨ। ਇੱਕ ਯਾਦਗਾਰ ਸਟੇਜ। 8–9 ਅਗਸਤ 2026 ਨੂੰ RGMC ਜਿਮਖਾਨਾ ਕਲੱਬ, ਪਟਿਆਲਾ ਵਿੱਚ ਆਪਣੇ ਬੱਚੇ ਦੀ ਜਗ੍ਹਾ ਬੁੱਕ ਕਰੋ। ਹਰ ਰਜਿਸਟ੍ਰੇਸ਼ਨ WhatsApp 'ਤੇ ਨਿੱਜੀ ਤੌਰ 'ਤੇ ਪੁਸ਼ਟੀ ਕੀਤੀ ਜਾਂਦੀ ਹੈ।",
      perks: ["100+ ਨੌਜਵਾਨ ਟੈਲੇਂਟ", "ਕਈ ਪ੍ਰਦਰਸ਼ਨ ਸ਼੍ਰੇਣੀਆਂ", "ਮਾਹਿਰ ਜੱਜ ਤੇ ਦਿਲਚਸਪ ਇਨਾਮ", "ਹਰ ਭਾਗੀਦਾਰ ਲਈ ਸਰਟੀਫਿਕੇਟ"],
      categories: ["ਗਾਇਨ", "ਨਾਚ", "ਅਦਾਕਾਰੀ ਤੇ ਡਰਾਮਾ", "ਸਾਜ਼ ਸੰਗੀਤ", "ਮਾਡਲਿੰਗ / ਰੈਂਪ ਵਾਕ", "ਕਹਾਣੀ ਤੇ ਜਨਤਕ ਭਾਸ਼ਣ", "ਫੈਸ਼ਨ ਤੇ ਵੰਨ-ਸੁਵੰਨੀਆਂ ਕਲਾਵਾਂ"],
      urgency: "ਕੁਝ ਸੀਟਾਂ ਬਾਕੀ",
      feeLabel: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫੀਸ",
      feeOnly: "ਸਿਰਫ਼",
      payment: {
        title: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫੀਸ ਦਾ ਭੁਗਤਾਨ ਕਰੋ",
        subtitle: "ਕਿਸੇ ਵੀ UPI ਐਪ (GPay, PhonePe, Paytm, BHIM) ਨਾਲ QR ਸਕੈਨ ਕਰੋ ਜਾਂ ਹੇਠਾਂ ਦਿੱਤੀ UPI ID 'ਤੇ ਭੁਗਤਾਨ ਕਰੋ।",
        upiLabel: "UPI ID",
        payeeLabel: "ਭੁਗਤਾਨ ਪ੍ਰਾਪਤਕਰਤਾ",
        scanHint: "ਭੁਗਤਾਨ ਲਈ ਸਕੈਨ ਕਰੋ",
        after: "ਭੁਗਤਾਨ ਤੋਂ ਬਾਅਦ, ਹੇਠਾਂ ਟੈਪ ਕਰੋ ਤੇ ਆਪਣੇ ਬੱਚੇ ਦੀ ਸੀਟ ਪੱਕੀ ਕਰਨ ਲਈ WhatsApp 'ਤੇ ਭੁਗਤਾਨ ਸਕ੍ਰੀਨਸ਼ਾਟ ਸਾਂਝਾ ਕਰੋ।",
        paidBtn: "ਭੁਗਤਾਨ ਹੋ ਗਿਆ — WhatsApp 'ਤੇ ਪੁਸ਼ਟੀ ਕਰੋ",
      },
      childName: "ਬੱਚੇ ਦਾ ਨਾਮ *",
      childNamePh: "ਨੰਨ੍ਹੇ ਸਿਤਾਰੇ ਦਾ ਨਾਮ",
      age: "ਉਮਰ (3–15) *",
      agePh: "ਜਿਵੇਂ 8",
      city: "ਸ਼ਹਿਰ",
      cityPh: "ਪਟਿਆਲਾ",
      category: "ਪ੍ਰਦਰਸ਼ਨ ਸ਼੍ਰੇਣੀ *",
      categoryPh: "ਇੱਕ ਸ਼੍ਰੇਣੀ ਚੁਣੋ",
      parentName: "ਮਾਪੇ ਦਾ ਨਾਮ *",
      parentNamePh: "ਤੁਹਾਡਾ ਨਾਮ",
      phone: "WhatsApp ਨੰਬਰ *",
      phonePh: "10-ਅੰਕਾਂ ਦਾ ਮੋਬਾਈਲ",
      note: "ਸਾਡੇ ਲਈ ਇੱਕ ਨੋਟ (ਵਿਕਲਪਿਕ)",
      notePh: "ਕੁਝ ਜੋ ਤੁਸੀਂ ਸਾਨੂੰ ਦੱਸਣਾ ਚਾਹੋ?",
      submit: "ਮੇਰੀ ਜਗ੍ਹਾ ਬੁੱਕ ਕਰੋ",
      submitting: "ਬੁੱਕ ਹੋ ਰਿਹਾ...",
      disclaimer: "ਹੁਣ ਕੋਈ ਭੁਗਤਾਨ ਨਹੀਂ — ਅਸੀਂ WhatsApp 'ਤੇ ਸਭ ਪੁਸ਼ਟੀ ਕਰਾਂਗੇ।",
      errFill: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਲੋੜੀਂਦੇ ਖਾਨੇ ਭਰੋ।",
      errAge: "ਉਮਰ 3 ਤੋਂ 15 ਸਾਲ ਵਿਚਕਾਰ ਹੋਣੀ ਚਾਹੀਦੀ ਹੈ।",
      toast: "ਜਗ੍ਹਾ ਬੁੱਕ! 🎉 ਪੱਕਾ ਕਰਨ ਲਈ WhatsApp 'ਤੇ ਪੁਸ਼ਟੀ ਕਰੋ।",
      success: {
        title: "ਤੁਸੀਂ ਸੂਚੀ ਵਿੱਚ ਹੋ!",
        ref: "ਬੁਕਿੰਗ ਹਵਾਲਾ",
        step: "ਆਖਰੀ ਕਦਮ — ਸਾਨੂੰ ਇੱਕ ਤੁਰੰਤ WhatsApp ਭੇਜੋ ਤਾਂ ਜੋ ਅਸੀਂ {name} ਦੀ ਜਗ੍ਹਾ ਪੱਕੀ ਕਰ ਸਕੀਏ ਤੇ ਸ਼ੈਡਿਊਲ ਸਾਂਝਾ ਕਰੀਏ।",
        whatsapp: "WhatsApp 'ਤੇ ਪੁਸ਼ਟੀ ਕਰੋ",
        another: "ਕਿਸੇ ਹੋਰ ਬੱਚੇ ਨੂੰ ਰਜਿਸਟਰ ਕਰੋ",
        share: "ਸ਼ੇਅਰ ਕਾਰਡ ਬਣਾਓ",
        shareTitle: "ਖੁਸ਼ੀ ਸਾਂਝੀ ਕਰੋ!",
        shareHint: "ਇਸ ਨੂੰ ਸੰਭਾਲੋ ਤੇ ਇੰਸਟਾਗ੍ਰਾਮ 'ਤੇ ਪੋਸਟ ਕਰੋ — @littlesapiens.pta ਨੂੰ ਟੈਗ ਕਰੋ!",
        download: "ਡਾਊਨਲੋਡ",
        shareBtn: "ਸ਼ੇਅਰ",
      },
      waText: "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ Little Sapiens! 🌟 Sapiens Celestia 2026 ਲਈ ਨਵੀਂ ਰਜਿਸਟ੍ਰੇਸ਼ਨ:\n\nਬੱਚਾ: {name} (ਉਮਰ {age})\nਸ਼੍ਰੇਣੀ: {cat}\nਮਾਪੇ: {parent}\nWhatsApp: {phone}\nਸ਼ਹਿਰ: {city}\nਬੁਕਿੰਗ ਹਵਾਲਾ: {ref}\n\nਮੈਂ ₹1,000 ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫੀਸ ਦਾ ਭੁਗਤਾਨ ਕਰ ਦਿੱਤਾ ਹੈ ਤੇ ਭੁਗਤਾਨ ਸਕ੍ਰੀਨਸ਼ਾਟ ਇੱਥੇ ਸਾਂਝਾ ਕਰਾਂਗਾ। ਕਿਰਪਾ ਕਰਕੇ ਸੀਟ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ।",
    },
    footer: {
      legacyEyebrow: "ਭਵਿੱਖ ਦੀ ਦ੍ਰਿਸ਼ਟੀ",
      legacyTitle: "ਇੱਕ ਵਿਰਾਸਤ ਦੀ",
      legacyAccent: "ਸ਼ੁਰੂਆਤ",
      legacyBody: "ਸਾਡੀ ਦ੍ਰਿਸ਼ਟੀ ਸੇਪੀਅਨਜ਼ ਸੇਲੇਸਟੀਆ ਨੂੰ ਉੱਤਰੀ ਭਾਰਤ ਦੇ ਸਭ ਤੋਂ ਸਤਿਕਾਰਯੋਗ ਬਾਲ ਟੈਲੇਂਟ ਮੇਲਿਆਂ ਵਿੱਚੋਂ ਇੱਕ ਬਣਾਉਣ ਦੀ ਹੈ — ਪੰਜਾਬ, ਗੁਆਂਢੀ ਰਾਜਾਂ ਤੇ ਅੰਤ ਵਿੱਚ ਪੂਰੇ ਭਾਰਤ ਦੇ ਨੌਜਵਾਨ ਕਲਾਕਾਰਾਂ ਦਾ ਸੁਆਗਤ ਕਰਦੇ ਹੋਏ।",
      legacyNote: "ਲਿਟਲ ਸੇਪੀਅਨਜ਼ ਦਾ ਪਟਿਆਲਾ ਵਿੱਚ ਪਹਿਲਾ ਫਲੈਗਸ਼ਿਪ ਪ੍ਰੀਮੀਅਮ ਟੈਲੇਂਟ ਮੰਚ — ਵਿਸ਼ਵ ਮਿਆਰਾਂ ਤੋਂ ਪ੍ਰੇਰਿਤ।",
      legacyCta: "ਪਹਿਲੇ ਐਡੀਸ਼ਨ ਦਾ ਹਿੱਸਾ ਬਣੋ",
      venueTitle: "ਰੈਂਪ ਲੱਭੋ",
      venueName: "RGMC ਜਿਮਖਾਨਾ ਕਲੱਬ, ਪਟਿਆਲਾ",
      venueBody: "ਸੁਨਹਿਰੀ ਚਮਕ ਦੇ ਪਿੱਛੇ ਜਿਮਖਾਨਾ ਕਲੱਬ ਰੋਡ ਵੱਲ ਚੱਲੋ — ਜਿੱਥੇ ਪਟਿਆਲਾ ਦੇ ਪੁਰਾਣੇ ਦਰੱਖਤ ਰਾਹ ਸਜਾਉਂਦੇ ਹਨ। ਜਦੋਂ ਖੁਸ਼ ਪਰਿਵਾਰ ਤੇ ਸਟੇਜ ਦੀਆਂ ਰੌਸ਼ਨੀਆਂ ਦਿਖਣ, ਤੁਸੀਂ ਪਹੁੰਚ ਗਏ! ✨",
      mapsCta: "ਗੂਗਲ ਮੈਪਸ ਵਿੱਚ ਖੋਲ੍ਹੋ",
      whatsappChat: "WhatsApp 'ਤੇ ਗੱਲ ਕਰੋ",
      homeTitle: "ਸਾਡਾ ਨੰਨ੍ਹਾ ਘਰ",
      homeName: "ਲਿਟਲ ਸੇਪੀਅਨਜ਼ · ਅਰਲੀ ਯੀਅਰਜ਼, ਪਟਿਆਲਾ",
      homeBody: "ਪਟਿਆਲਾ ਦੇ ਇੱਕ ਖੁਸ਼ਨੁਮਾ ਕੋਨੇ ਵਿੱਚ ਜਿੱਥੇ ਕ੍ਰੇਯਾਨ ਉਤਸੁਕਤਾ ਨੂੰ ਮਿਲਦੇ ਹਨ। ਹੈਲੋ ਕਹਿਣ ਆਓ — ਇੱਥੇ ਹਮੇਸ਼ਾ ਕੋਈ ਕਹਾਣੀ ਤੇ ਨੰਨ੍ਹਾ ਨਾਚ ਚੱਲ ਰਿਹਾ ਹੁੰਦਾ ਹੈ। 🎨",
      contactTitle: "ਹੈਲੋ ਕਹੋ",
      whatsapp: "WhatsApp",
      call: "ਕਾਲ",
      copyright: "© 2026 ਲਿਟਲ ਸੇਪੀਅਨਜ਼ ਅਰਲੀ ਯੀਅਰਜ਼, ਪਟਿਆਲਾ। ਨੰਨ੍ਹੇ ਸੁਪਨਸਾਜ਼ਾਂ ਲਈ ਪਿਆਰ ਨਾਲ ਬਣਾਇਆ।",
      credit: "ਡਿਜ਼ਾਈਨ ਤੇ ਵਿਕਾਸ — M Sivanath",
      waText: "ਸਤਿ ਸ੍ਰੀ ਅਕਾਲ Little Sapiens! ਮੈਂ Sapiens Celestia 2026 ਬਾਰੇ ਹੋਰ ਜਾਣਨਾ ਚਾਹਾਂਗਾ।",
    },
  },
};
